"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllLaybyProducts = exports.isLaybyProduct = void 0;
var LAYBUY = "laybuy";
var isLaybyProduct = function (product) {
    if (!product || !product.attributes || !Array.isArray(product.attributes)) {
        return false;
    }
    var laybyOption = product.attributes.find(function (attribute) { return attribute.name.toLowerCase() === LAYBUY && attribute.default_value === true && attribute.type.toLowerCase() === "boolean"; });
    if (!laybyOption)
        return false;
    return true;
};
exports.isLaybyProduct = isLaybyProduct;
var isAllLaybyProducts = function (productList) {
    var _a;
    for (var _i = 0, productList_1 = productList; _i < productList_1.length; _i++) {
        var product = productList_1[_i];
        if (((_a = product === null || product === void 0 ? void 0 : product.attributes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var result = (0, exports.isLaybyProduct)(product);
            if (!result)
                return false;
        }
        else {
            return false;
        }
    }
    return true;
};
exports.isAllLaybyProducts = isAllLaybyProducts;
